<template>
  <div>
    <div class="ls_drawer_main_content">

      <div @click="cancelAction()" class="align-center mb-50" style="cursor: pointer; display: inline-flex">
        <Icon type="ios-arrow-back"/>
        <h2 style="margin-left: 20px" v-if="action === 'create'">Создание товара</h2>
        <h2 style="margin-left: 20px" v-else>Редактирование товара</h2>
      </div>

      <Form :model="formData" ref="formData" :rules="rules">

        <Row type="flex" justify="space-between">
          <!-- PRODUCT TYPE -->
          <Col cols="24" :lg='6' :xl="4"
               v-if="action === 'create'"
               :gutter="32"
               style="text-align: center"
               class="unselectable">
            <div
              class="card-container"
              :class="{
                form__product_type__active: formData.type === TYPE_PRODUCT,
                form__product_type: formData.type !== TYPE_PRODUCT
              }"
              @click="setProductType(TYPE_PRODUCT)"
            >
              <h2 slot="title">Товар</h2>
              <p class="form__product_type__text">
                Продукт, имеющий остаток, который необходимо восполнять
              </p>
            </div>

            <div
              class="card-container"
              :class="{
                form__product_type__active: formData.type === TYPE_SERVICE,
                form__product_type: formData.type !== TYPE_SERVICE
              }"
              @click="setProductType(TYPE_SERVICE)"
            >
              <h2 class="form__product_type__title" slot="title">Услуга</h2>
              <p class="form__product_type__text">
                Продукт, не имеющий остатка на складе
              </p>
            </div>

            <div
              class="card-container"
              :class="{
                form__product_type__active: formData.type === TYPE_KIT,
                form__product_type: formData.type !== TYPE_KIT
              }"
              @click="setProductType(TYPE_KIT)"
            >
              <h2 class="form__product_type__title" slot="title">Комплект</h2>
              <p class="form__product_type__text">
                Продукт, состоящий из нескольких других
              </p>
            </div>
          </Col>


          <Col :xs="24" :sm="24" :md="24" :lg='17' :xl="19">

            <Row type="flex" justify="space-between">
              <Col :xs="24" :sm="24" :md="24" :lg="12" class="left__col">
                <!-- NAME -->
                <FormItem prop="name" :label="schema.name.label" class="mb-30">
                  <Input class="border_30" v-model="formData.name" :placeholder="schema.name.label"/>
                </FormItem>

                <!-- IMAGE -->
                <div v-if="formData.image_url" class="upload_image">
                  <img :src="image_url_full"/>
                  <div class="upload_image_cover">
                    <Icon type="ios-trash-outline" @click.native="deleteImage"></Icon>
                  </div>
                </div>

                <Upload
                  class="mb-30"
                  v-else
                  type="drag"
                  :action="upload_url"
                  :headers="{ Authorization: 'Bearer ' + token }"
                  :on-success="onSuccessImageUpload"
                >
                  <div style="padding: 20px 0">
                    <Icon type="md-cloud-upload" size="50"/>
                    <p>Загрузите изображение</p>
                  </div>
                </Upload>

                <!-- BARCODE-->
                <div class="d-flex mb-30">
                  <FormItem :label="schema.barcode.label" style="margin-bottom: 0; width: calc(100% - 100px)">
                    <Input
                      class="border_30"
                      v-model="formData.barcode"
                      style="display: inline-block"
                      :placeholder="schema.barcode.label"
                    />
                  </FormItem>
                  <Button
                    class="border_30"
                    :disabled="generatedBarcode"
                    @click="generateBarcode"
                    style="margin-top: 35px;margin-left: -50px; display: inline-block; position: relative; z-index: 2"
                    type="info"
                  >Сгенерировать
                  </Button>
                </div>

                <!--SKU-->
                <FormItem :label="schema.sku.label">
                  <Input class="border_30" v-model="formData.sku" :placeholder="schema.sku.label"/>
                </FormItem>

                <FormItem :label="schema.exclude_store_ids.label" style="margin-bottom: 0">
                  <Select v-model="formData.exclude_store_ids" filterable multiple>
                    <Option
                      v-for="item in formSelectOptions.stores"
                      :value="item.id"
                      :key="item.id"
                    >{{ item.name }}</Option
                    >
                    <!--<Option value="KZ">Группа 1</Option>-->
                    <!--<Option value="RU">Группа 2</Option>-->
                  </Select>
                </FormItem>
              </Col>

              <Col :xs="24" :sm="24" :md="24" :lg="12" class="right__col">
                <!-- GROUP -->
                <Row :gutter="32">
                  <Col span="18">
                    <Row type="flex" align="bottom" class="mb-24">
                      <Col span="20">
                        <FormItem :label="schema.group.label" style="margin-bottom: 0">
                          <Select v-model="formData.group" filterable>
                            <Option
                              v-for="item in formSelectOptions.group"
                              :value="item.id"
                              :key="item.id"
                            >{{ item.name }}
                            </Option
                            >
                            <!--<Option value="KZ">Группа 1</Option>-->
                            <!--<Option value="RU">Группа 2</Option>-->
                          </Select>
                        </FormItem>
                      </Col>
                      <Col span="4">
                        <Tooltip content="Добавление новой группы" placement="left-end">
                          <Button
                            class="btn-small border_30 btn-add"
                            @click="newGroupModal.show = true"
                            type="success"
                            icon="md-add"
                          ></Button>
                        </Tooltip>
                        <Modal
                          v-model="newGroupModal.show"
                          title="Группы товаров"
                          width="750"
                        >
                          <!--<Input-->
                          <!--v-model="newSupplierModal.value"-->
                          <!--placeholder="Введите наименование поставщика"-->
                          <!--style="width: 100%"-->
                          <!--/>-->
                          <groupTree @new-group="attachNewGroup"></groupTree>
                          <div slot="footer">
                            <Button
                              type="error"
                              size="large"
                              @click="newGroupModal.show = false"
                            >Закрыть
                            </Button
                            >
                            <!--<Button-->
                            <!--:disabled="!newGroupModal.value"-->
                            <!--type="primary"-->
                            <!--size="large"-->
                            <!--:loading="newGroupModal.modal_loading"-->
                            <!--@click="newSupplierModalSave"-->
                            <!--&gt;Добавить</Button-->
                            <!--&gt;-->
                          </div>
                        </Modal>
                      </Col>
                    </Row>
                  </Col>
                </Row>

                <!-- UNIT | IS_WEIGHED -->
                <Row type="flex" align="middle" class="mb-24">
                  <Col :xl="12">
                    <FormItem :label="schema.unit.label" label-position="top" style="margin-bottom: 0">
                      <Input class="border_30" v-model="formData.unit" :placeholder="schema.unit.label"/>
                    </FormItem>
                  </Col>

                  <Col :xl="12">
                    <FormItem
                      style="margin-bottom: 0; margin-top: 36px"
                    >
                      <div class="switch-custom">
                        <i-switch v-model="formData.is_weighed"></i-switch>
                        <span>Весовой товар</span>
                      </div>

                    </FormItem>
                  </Col>



                </Row>

                <!-- COUNTRY -->
                <FormItem :label="schema.country.label" label-position="top" v-if="formData.type === TYPE_PRODUCT">
                  <Select v-model="formData.country" filterable>
                    <Option
                      v-for="item in schema.country.choices"
                      :value="item.value"
                      :key="item.value"
                    >{{ item.display_name }}
                    </Option
                    >
                  </Select>
                </FormItem>

                <!-- DESCRIPTION -->
                <FormItem :label="schema.description.label">
                  <Input
                    class="border_30"
                    type="textarea"
                    v-model="formData.description"
                    :rows="4"
                    :placeholder="schema.description.label"
                  />
                </FormItem>
              </Col>
            </Row>


            <Row>
              <Divider dashed="true"><h2>Цены</h2></Divider>

              <!-- PURCHASE | MARKUP | BASE_PRICE | TRADE PRICE -->
              <Row :gutter="32">
                <Col :lg="6" v-if="formData.type === TYPE_PRODUCT">
                  <FormItem :label="purchase_label">
                    <!--<Input v-model="formData.purchase" type="number" style="z-index: 0">-->
                    <!--<span slot="append">руб.</span>-->
                    <!--</Input>-->
                    <InputNumber
                      class="border_30"
                      style="width: 100%"
                      :min="0"
                      @input="onChangePurchase"
                      v-model="formData.purchase"
                    ></InputNumber>
                  </FormItem>
                </Col>
                <Col :lg="6" v-if="formData.type === TYPE_PRODUCT">
                  <FormItem :label="markup_label">
                    <!--<Input-->
                    <!--v-model="formData.markup_price"-->
                    <!--type="number"-->
                    <!--style="z-index: 0"-->
                    <!--&gt;-->
                    <!--<span slot="append">%</span>-->
                    <!--</Input>-->
                    <InputNumber
                      class="border_30"
                      style="width: 100%"
                      :min="0"
                      @input="onChangeMarkupPrice"
                      v-model="formData.markup_price"
                    ></InputNumber>
                  </FormItem>
                </Col>
                <Col :lg="6">
                  <FormItem :label="base_price_label">
                    <!--<Input v-model="formData.base_price" type="number" style="z-index: 0">-->
                    <!--<span slot="append">руб.</span>-->
                    <!--</Input>-->
                    <InputNumber
                      class="border_30"
                      style="width: 100%"
                      :min="0"
                      @input="onChangeBasePrice"
                      v-model="formData.base_price"
                    ></InputNumber>
                  </FormItem>
                </Col>
                <Col :lg="6" v-if="formData.type !== TYPE_SERVICE">
                  <FormItem :label="trade_price_label">
                    <!--<Input v-model="formData.base_price" type="number" style="z-index: 0">-->
                    <!--<span slot="append">руб.</span>-->
                    <!--</Input>-->
                    <InputNumber
                      class="border_30"
                      style="width: 100%"
                      :min="0"
                      @input="onChangeTradePrice"
                      v-model="formData.trade_price"
                    ></InputNumber>
                  </FormItem>
                </Col>
              </Row>

              <!-- PRICES BY STORES -->
              <!--Показывать, если магазинов больше чем 1-->
              <div v-if="formSelectOptions.stores.length > 1">
                <FormItem class="d-flex align-center">
                  <div class="switch-custom">
                    <i-switch v-model="formExtra.prices_by_stores"></i-switch>
                    <span>Установить разные цены в магазинах</span>
                  </div>

                </FormItem>

                <Card v-if="formExtra.prices_by_stores" style="background-color: #EBEBED" class="mb-30">
                  <Row :gutter="32" type="flex" justify="space-between">
                    <Col :xs="11" :sm="14" class="fs-16"
                    >Магазин
                    </Col
                    >
                    <Col :xs="8" :sm="5" class="fs-16" style="margin-bottom: 24px">{{
                      base_price_label
                      }}
                    </Col>
                    <template v-if="formData.type !== TYPE_SERVICE">
                    <Col :xs="8" :sm="5" class="fs-16" style="margin-bottom: 24px">{{
                      trade_price_label
                      }}
                    </Col>
                    </template>
                  </Row>

                  <Row
                    type="flex" justify="space-between"
                    style="margin-bottom: 24px"
                    :gutter="32"
                    v-for="(item, counter) in formData.prices_by_stores"
                    :key="item.store"
                  >

                    <Col :xs="10" :sm="13">
                      <div class="card-container card-container__label">
                        {{ item.store_name }}
                      </div>
                    </Col>
                    <Col :xs="8" :sm="5">
                      <FormItem style="margin-bottom: 0">
                        <InputNumber
                          class="border_30"
                          :min="0"
                          style="width: 100%"
                          v-model="formData.prices_by_stores[counter].value"
                        ></InputNumber>
                      </FormItem>
                    </Col>
                    <template v-if="formData.type !== TYPE_SERVICE">
                    <Col :xs="8" :sm="5">
                      <FormItem style="margin-bottom: 0">
                        <InputNumber
                          class="border_30"
                          :min="0"
                          style="width: 100%"
                          v-model="formData.prices_by_stores[counter].trade_value"
                        ></InputNumber>
                      </FormItem>
                    </Col>
                    </template>
                  </Row>
                </Card>
              </div>
            </Row>


            <!-- DISCOUNT | VAT -->
            <Row :gutter="32">
              <Col span="12">
                <FormItem :label="discount_label">
                  <!--<Input v-model="formData.discount" type="number" style="z-index: 0">-->
                  <!--<span slot="append">%</span>-->
                  <!--</Input>-->
                  <InputNumber
                    class="border_30"
                    style="width: 100%"
                    :min="0"
                    v-model="formData.discount"
                  ></InputNumber>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem :label="vat_label">
                  <!--<Input v-model="formData.vat" type="number" style="z-index: 0">-->
                  <!--<span slot="append">%</span>-->
                  <!--</Input>-->
                  <InputNumber
                    class="border_30"
                    style="width: 100%"
                    :min="0"
                    v-model="formData.vat"
                  ></InputNumber>
                </FormItem>
              </Col>
            </Row>

            <Divider dashed="true" v-if="formData.type === TYPE_PRODUCT"><h2>Склад</h2></Divider>

            <div class="alert-msg d-flex align-center" v-if="formData.type === TYPE_PRODUCT">
              <img src="/static/svg/attention.svg" alt="">
              <div>
                <h2>Ведение остатков</h2>
                Для внесения остатков на склад воспользуйетсь документом "Закупка" либо "Оприходование".
              </div>

            </div>


            <!--            &lt;!&ndash; CODE  &ndash;&gt;-->
            <!--            <Row :gutter="32">-->
            <!--              <Col span="7">-->
            <!--                <FormItem :label="labelCode">-->
            <!--                  <Input-->
            <!--                    v-model="formData.code"-->
            <!--                    :placeholder="schema.code.label"-->
            <!--                    disabled-->
            <!--                  />-->
            <!--                </FormItem>-->
            <!--              </Col>-->
            <!--            </Row>-->


            <!-- KIT COMPOSITION -->
            <Divider v-if="formData.type === TYPE_KIT" dashed="true" class="mb-50"><h2>Состав комплекта</h2></Divider>

            <div v-if="formData.type === TYPE_KIT">

              <!-- SOURCE AND TARGET TABLES -->
              <Row :gutter="32" type="flex" justify="space-between">
                <Col :xs="24" :sm="24" :md="24" :lg="10" :xl="8">


                  <!-- SEARCH -->
                  <FormItem>
                    <Input
                      class="border_30"
                      v-model="kit_composition.search_value"
                      suffix="ios-search"
                      placeholder="Введите наименование/артикул/код"
                      style="width: 100%"
                    />
                  </FormItem>

                  <div
                    style="display: block"
                    class="card-container сard-container__type-kit"
                  >
                    <Table
                      class="desktop_table"
                      :data="kit_composition.source_table.data"
                      :columns="kit_composition.source_table.columns"
                      :loading="kit_composition.source_table.loading"
                      :show-header="false"
                      @on-row-click="addToKitTargetTable"
                    ></Table>

                    <Table
                      v-if="kit_composition.search_value"
                      class="mobile-table"
                      :data="kit_composition.source_table.data"
                      :columns="kit_composition.source_table.columns"
                      :loading="kit_composition.source_table.loading"
                      :show-header="false"
                      @on-row-click="addToKitTargetTable"
                    ></Table>


                    <Button
                      class="desktop_table"
                      v-show="
                    kit_composition.source_table.current_page *
                      kit_composition.source_table.limit <
                      kit_composition.source_table.total_records
                  "
                      style="width: 100%"
                      type="info"
                      @click="kit_composition.source_table.current_page++"
                    >Показать еще
                    </Button
                    >
                  </div>
                </Col>
                <Col :xs="24" :sm="24" :md="24" :lg="14" :xl="15">
                  <Row :gutter="32" class="mb-50 desktop_table" style="margin-top: 15px">
                    <Col span="9" class="fs-16 color-grey"
                    >Наименование
                    </Col
                    >
                    <Col span="6" style="text-align: center" class="fs-16 color-grey"
                    >Количество
                    </Col
                    >
                    <Col span="5" style="text-align: center" class="fs-16 color-grey"
                    >Стоимость
                    </Col
                    >
                    <Col span="2"></Col>
                  </Row>



                  <div
                    class="no-select"
                    v-if="kit_composition.target_table.length === 0"
                  >

                    <span class="desktop_table">
                      <Icon type="md-arrow-back" />
                      Выберите товары
                    </span>

                    <span class="mobile-table">

                      <Icon type="md-arrow-up" /> <br>
                      Выберите товары <br> (введите наименование в строке поиска)
                    </span>

                  </div>


                  <Row
                    class="mb-15 desktop_table"
                    type="flex"
                    align="middle"
                    v-for="(product, counter) in kit_composition.target_table"
                    :key="product.id"
                    :gutter="32"
                  >
                    <Divider
                      v-if="counter > 0"
                      style="margin: 0 0 10px 0;"
                    ></Divider>
                    <Col span="9">
                      <div class="fs-16">{{ product.name }}</div>
                      <small class="color-grey fs-14">Цена за единицу: {{ product.base_price }}</small>
                    </Col>
                    <Col span="6" style="text-align: center">
                      <FormItem style="margin-bottom: 0">
                        <InputNumber
                          class="border_30"
                          style="width: 100%; height: 32px; padding: 0 24px"
                          :min="1"
                          v-model="kit_composition.target_table[counter].count"
                        ></InputNumber>
                      </FormItem>
                    </Col>
                    <Col span="5" style="text-align: center" class="fs-16">
                      {{
                      formatNumber(
                      parseFloat((kit_composition.target_table[counter].base_price *
                      kit_composition.target_table[counter].count).toFixed(2))
                      )
                      }}
                    </Col>
                    <Col span="2" style="text-align: center">
                      <Button
                        style="float: right; padding: 0; color: #EF6E57; box-shadow: none; border: none"
                        icon="md-trash"
                        @click="deleteFromKitTargetTable(product.id)"
                      ></Button>
                    </Col>
                  </Row>




                  <!-- MOBILE TABLE OF SELECTED PRODUCTS-->
                  <div class="mobile-table">
                    <div class="card-container"
                         v-for="(product, counter) in kit_composition.target_table"
                         :key="product.id">
                      <div>
                        <h2 style="padding-left: 0">{{product.name}}</h2>

                        <div>
                          Цена за единицу: {{ product.base_price }}
                        </div>

                        <div class="d-flex align-center">
                          Количество:
                          <FormItem style="margin-bottom: 0">
                            <InputNumber
                              class="border_30"
                              style="width: 70px; height: 32px; padding: 0 10px; margin-left: 12px"
                              :min="1"
                              v-model="kit_composition.target_table[counter].count"
                            ></InputNumber>
                          </FormItem>
                        </div>

                        <h2 style="padding-left: 0">
                          Стоимость: {{
                          formatNumber(
                          kit_composition.target_table[counter].base_price *
                          kit_composition.target_table[counter].count
                          )
                          }} {{currency}}
                        </h2>
                      </div>

                      <div>
                        <Button
                          style="float: right; padding: 0; color: #EF6E57; box-shadow: none; border: none"
                          icon="md-trash"
                          @click="deleteFromKitTargetTable(product.id)"
                        ></Button>
                      </div>
                    </div>
                  </div>



                </Col>
              </Row>
            </div>

          </Col>
        </Row>


        <!--        &lt;!&ndash; CATEGORIES &ndash;&gt;-->
        <!--        <Row>-->
        <!--          <Col span="22">-->
        <!--            <FormItem :label="schema.categories.label">-->
        <!--              <Select v-model="formData.categories" filterable multiple>-->
        <!--                <Option-->
        <!--                  v-for="item in formSelectOptions.category"-->
        <!--                  :value="item.id"-->
        <!--                  :key="item.id"-->
        <!--                  >{{ item.name }}</Option-->
        <!--                >-->
        <!--              </Select>-->
        <!--            </FormItem>-->
        <!--          </Col>-->
        <!--          <Col span="2">-->
        <!--            <Tooltip content="Добавление новой категории" placement="left-end">-->
        <!--              <Button-->
        <!--                @click="newCategoryModal.show = true"-->
        <!--                style="margin-top: 33px;margin-left: 10px;"-->
        <!--                type="success"-->
        <!--                icon="md-add"-->
        <!--              ></Button>-->
        <!--            </Tooltip>-->
        <!--            <Modal-->
        <!--              v-model="newCategoryModal.show"-->
        <!--              title="Добавление новой категории"-->
        <!--            >-->
        <!--              <Input-->
        <!--                v-model="newCategoryModal.value"-->
        <!--                placeholder="Введите название категории"-->
        <!--                style="width: 100%"-->
        <!--              />-->
        <!--              <div slot="footer">-->
        <!--                <Button-->
        <!--                  type="error"-->
        <!--                  ghost-->
        <!--                  size="large"-->
        <!--                  @click="newCategoryModal.show = false"-->
        <!--                  >Закрыть</Button-->
        <!--                >-->
        <!--                <Button-->
        <!--                  :disabled="!newCategoryModal.value"-->
        <!--                  type="primary"-->
        <!--                  size="large"-->
        <!--                  :loading="newCategoryModal.modal_loading"-->
        <!--                  @click="newCategoryModalSave"-->
        <!--                  >Добавить</Button-->
        <!--                >-->
        <!--              </div>-->
        <!--            </Modal>-->
        <!--          </Col>-->
        <!--        </Row>-->


        <!--        &lt;!&ndash; SUPPLIER | MIN_REST &ndash;&gt;-->
        <!--        <Row-->
        <!--          :gutter="32"-->
        <!--          type="flex"-->
        <!--          justify="space-between"-->
        <!--          v-if="formData.type === TYPE_PRODUCT"-->
        <!--        >-->
        <!--          <Col span="12">-->
        <!--            <Row>-->
        <!--              <Col span="22">-->
        <!--                <FormItem :label="schema.supplier.label">-->
        <!--                  <Select v-model="formData.supplier" filterable>-->
        <!--                    <Option-->
        <!--                      v-for="item in formSelectOptions.supplier"-->
        <!--                      :value="item.id"-->
        <!--                      :key="item.id"-->
        <!--                      >{{ item.name }}</Option-->
        <!--                    >-->
        <!--                    &lt;!&ndash;<Option value="KZ">Поставщик 1</Option>&ndash;&gt;-->
        <!--                    &lt;!&ndash;<Option value="RU">Поставщик 2</Option>&ndash;&gt;-->
        <!--                  </Select>-->
        <!--                </FormItem>-->
        <!--              </Col>-->
        <!--              <Col span="2">-->
        <!--                <Tooltip-->
        <!--                  content="Добавление нового поставщика"-->
        <!--                  placement="left-end"-->
        <!--                >-->
        <!--                  <Button-->
        <!--                    @click="newSupplierModal.show = true"-->
        <!--                    style="margin-top: 33px;margin-left: 10px;"-->
        <!--                    type="success"-->
        <!--                    icon="md-add"-->
        <!--                  ></Button>-->
        <!--                </Tooltip>-->
        <!--                <Modal-->
        <!--                  v-model="newSupplierModal.show"-->
        <!--                  title="Добавление поставщика"-->
        <!--                >-->
        <!--                  <Input-->
        <!--                    v-model="newSupplierModal.value"-->
        <!--                    placeholder="Введите наименование поставщика"-->
        <!--                    style="width: 100%"-->
        <!--                  />-->
        <!--                  <div slot="footer">-->
        <!--                    <Button-->
        <!--                      type="error"-->
        <!--                      ghost-->
        <!--                      size="large"-->
        <!--                      @click="newSupplierModal.show = false"-->
        <!--                      >Закрыть</Button-->
        <!--                    >-->
        <!--                    <Button-->
        <!--                      :disabled="!newSupplierModal.value"-->
        <!--                      type="primary"-->
        <!--                      size="large"-->
        <!--                      :loading="newSupplierModal.modal_loading"-->
        <!--                      @click="newSupplierModalSave"-->
        <!--                      >Добавить</Button-->
        <!--                    >-->
        <!--                  </div>-->
        <!--                </Modal>-->
        <!--              </Col>-->
        <!--            </Row>-->
        <!--          </Col>-->
        <!--          <Col span="10">-->
        <!--            <FormItem :label="min_rest_label">-->
        <!--              <InputNumber-->
        <!--                :min="0"-->
        <!--                style="width: 100%"-->
        <!--                v-model="formData.min_rest"-->
        <!--              ></InputNumber>-->
        <!--            </FormItem>-->
        <!--          </Col>-->
        <!--        </Row>-->

        <!-- PRODUCT MODIFICATIONS -->
        <!--<FormItem label="Товар с модификациями">-->
        <!--<i-switch v-model="formExtra.modifications"> </i-switch>-->
        <!--</FormItem>-->

        <!--        &lt;!&ndash; INITIAL REST BY STORES &ndash;&gt;-->
        <!--        <div v-if="formData.type === TYPE_PRODUCT">-->
        <!--          <FormItem-->
        <!--            :label="-->
        <!--              action === 'create'-->
        <!--                ? 'Ввести начальные остатки'-->
        <!--                : 'Изменить остатки'-->
        <!--            "-->
        <!--          >-->
        <!--            <i-switch v-model="formExtra.rest_by_stores"></i-switch>-->
        <!--          </FormItem>-->

        <!--          <Card v-if="formExtra.rest_by_stores" class="form_extra">-->
        <!--            <Row :gutter="32">-->
        <!--              <Col span="12" style="text-align: center; color: gray"-->
        <!--                >Магазин (склад)</Col-->
        <!--              >-->
        <!--              <Col span="12" style="text-align: center; color: gray">{{-->
        <!--                rest_label-->
        <!--              }}</Col>-->
        <!--            </Row>-->
        <!--            <Divider style="margin:0"></Divider>-->
        <!--            <Row-->
        <!--              :gutter="32"-->
        <!--              v-for="(item, counter) in formData.rest_by_stores"-->
        <!--              :key="item.store"-->
        <!--            >-->
        <!--              <Divider v-if="counter > 0" style="margin: 0 0 10px 0;"></Divider>-->
        <!--              <Col span="12" style="margin: 7px 0;">{{ item.store_name }}</Col>-->
        <!--              <Col span="12">-->
        <!--                <FormItem style="margin-bottom: 0">-->
        <!--                  <InputNumber-->
        <!--                    :min="0"-->
        <!--                    style="width: 100%"-->
        <!--                    v-model="formData.rest_by_stores[counter].value"-->
        <!--                  ></InputNumber>-->
        <!--                </FormItem>-->
        <!--              </Col>-->
        <!--            </Row>-->
        <!--          </Card>-->
        <!--        </div>-->

        <!--        &lt;!&ndash; EXPIRATION DATE &ndash;&gt;-->
        <!--        <Row :gutter="32" v-if="formData.type === 'PRODUCT'">-->
        <!--          <Col span="12">-->
        <!--            <FormItem :label="schema.expiration_date.label">-->
        <!--              <DatePicker-->
        <!--                type="date"-->
        <!--                :placeholder="schema.expiration_date.label"-->
        <!--                format="yyyy-MM-dd"-->
        <!--                :value="formData.expiration_date"-->
        <!--                @on-change="setExpireDate"-->
        <!--              ></DatePicker>-->
        <!--            </FormItem>-->
        <!--          </Col>-->
        <!--        </Row>-->
        <br/>
        <!--<br />-->
      </Form>
    </div>
    <div class="ls_drawer_footer" style="text-align: right">
      <Button style="margin-right: 8px" type="error" @click="cancelAction()">Отмена</Button>
      <Button
        type="success"
        @click="saveAction()"
        :disabled="disabledSaveButton"
      >Сохранить
      </Button
      >
    </div>

    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
    import {formatNumber} from "../../base/base_func.js";
    import {base_url, server_addr} from "../../http.js";
    import {BaseFormData} from "../../base/base_form_v2.js";
    import groupTree from "./groupTree.vue";

    let _app = BaseFormData();

    const TYPE_PRODUCT = "PRODUCT";
    const TYPE_SERVICE = "SERVICE";
    const TYPE_KIT = "KIT";

    _app.components = {
        groupTree
    };

    _app.data = function () {
        return {
            loading: true,
            baseRules: {},
            excludeFieldsRules: [],
            validForm: false,
            isChanged: false,
            kitHasBasePrice: true,
            kitHasTradePrice: true,
            isInitial: false,

            generatedBarcode: false,

            formData: {
                type: TYPE_PRODUCT,
                name: "",
                code: "",
                barcode: "",
                sku: "",
                categories: [],
                unit: "",
                description: "",
                country: "",
                purchase: 0,
                markup_price: 0,
                base_price: 0,
                trade_price: 0,
                discount: 0,
                vat: 0,
                // min_rest: 0,
                kit: [],
                rest_by_stores: [],
                prices_by_stores: [],
                image: "",
                image_url: "",
                exclude_store_ids: []
            },

            formDefaultInitData: {
                type: TYPE_PRODUCT,
                name: "",
                code: "",
                barcode: "",
                sku: "",
                categories: [],
                unit: "шт",
                description: "",
                country: "KZ",
                purchase: 0,
                markup_price: 0,
                base_price: 0,
                trade_price: 0,
                discount: 0,
                vat: null,
                // min_rest: 0,
                kit: [],
                rest_by_stores: [],
                prices_by_stores: [],
                image: "",
                image_url: "",
                exclude_store_ids: []
                // expiration_date: ''
            },
            formExtra: {
                prices_by_stores: false,
                modifications: false,
                // rest_by_stores: this.action === "edit"
            },
            formSelectOptions: {
                category: [],
                group: [],
                supplier: [],
                stores: []
            },

            newCategoryModal: {
                show: false,
                value: "",
                modal_loading: false
            },

            newSupplierModal: {
                show: false,
                value: "",
                modal_loading: false
            },

            newGroupModal: {
                show: false,
                value: "",
                modal_loading: false
            },

            upload_url: base_url + "/catalog/upload/",

            // currency: localStorage.getItem("currency"),

            // Вспомогательный объект для хранения промежуточной информации о комплекте
            kit_composition: {
                search_value: "",
                source_table: {
                    columns: [
                        {
                            key: "name",
                            className: "kit_source_table_column"
                        },
                        {
                            key: 'base_price',
                            align: 'right',
                            render: (h, params) => {
                                // return h("span", {}, formatNumber(params.row.purchase) + ' ' + this.currency);
                                return h("span", {}, formatNumber(params.row.base_price) + ' ' + this.currency);
                            }
                        }
                    ],
                    data: [],
                    total_records: 0,
                    last_draw: 0,
                    loading: false,
                    current_page: 1,
                    limit: 10
                },
                target_table: []
            }
        };
    };
    _app.computed.token = function () {
        return this.$store.state.access_token;
    };
    _app.computed.TYPE_PRODUCT = function () {
        return TYPE_PRODUCT;
    };
    _app.computed.TYPE_SERVICE = function () {
        return TYPE_SERVICE;
    };
    _app.computed.TYPE_KIT = function () {
        return TYPE_KIT;
    };

    _app.computed.labelCode = function () {
        return this.formData.type === TYPE_SERVICE ? "Код услуги" : "Код товара";
    };
    _app.computed.labelIsWeighed = function () {
        return this.formData.type === TYPE_SERVICE
            ? "Дробная услуга"
            : "Весовой товар";
    };
    _app.computed.image_url_full = function () {
        return server_addr + this.formData.image_url;
    };
    _app.computed.purchase_label = function () {
        if (this.currency) {
            return this.schema.purchase.label + " (" + this.currency + ")";
        }
        return this.schema.purchase.label;
    };
    _app.computed.markup_label = function () {
        return this.schema.markup_price.label + " (%)";
    };
    _app.computed.base_price_label = function () {
        //let label = this.formData.type !== TYPE_SERVICE ? "Розничная цена" : "Цена продажи";
        let label = "Розничная цена";
        if (this.currency) {
            return label + " (" + this.currency + ")";
        }
        return label;
    };
    _app.computed.trade_price_label = function () {
        let label = "Оптовая цена";
        if (this.currency) {
            return label + " (" + this.currency + ")";
        }
        return label;
    };
    _app.computed.discount_label = function () {
        return this.schema.discount.label + " (%)";
    };
    _app.computed.vat_label = function () {
        return this.schema.vat.label + " (%)";
    };
    // _app.computed.min_rest_label = function() {
    //   return this.formData.unit
    //     ? `${this.schema.min_rest.label} (${this.formData.unit})`
    //     : this.schema.min_rest.label;
    // };
    // _app.computed.rest_label = function() {
    //   return this.formData.unit ? `Остаток (${this.formData.unit})` : "Остаток";
    // };
    _app.computed.price_label = function () {
        return this.formData.unit
            ? `Цена продажи (${this.currency})`
            : "Цена продажи";
    };
    // Изменение типа продукта, а также сокрытие/показ всех связанных полей
    _app.methods.setProductType = function (type) {
        this.formData.type = type;
        this.formData.unit = type === TYPE_SERVICE ? "" : "шт";

        if (type === TYPE_KIT) {
            this.fetchProductsForKit();
        }
    };
    _app.methods.isType = function (type) {
        return this.formData.type === type;
    };

    // Справочники
    // _app.methods.getCategory = function() {
    //   const url = base_url + "/options/category/";
    //   this.$http
    //     .get(url)
    //     .then(result => {
    //       this.formSelectOptions.category = result.data.results;
    //     })
    // };
    _app.methods.getGroup = function () {
        const url = base_url + "/catalog/groups/";
        this.$http
            .get(url)
            .then(result => {
                this.formSelectOptions.group = result.data.results;
            })
    };
    // _app.methods.getSupplier = function() {
    //   const url = base_url + "/options/suppliers/";
    //   this.$http
    //     .get(url)
    //     .then(result => {
    //       this.formSelectOptions.supplier = result.data.results;
    //     })
    // };
    _app.methods.getStores = function () {
        const url = base_url + "/options/stores/";
        this.$http
            .get(url)
            .then(result => {
                this.formSelectOptions.stores = result.data.results;

                for (let store of this.formSelectOptions.stores) {
                    // Добавляем в соновную форму информацию по магазинам и остаткам

                    // let filter_by_rest = this.formData.rest_by_stores.filter(
                    //   item => item.store === store.id
                    // );
                    // // console.log(filter_by_rest);
                    //
                    // if (filter_by_rest.length === 0) {
                    //   this.formData.rest_by_stores.push({
                    //     store: store.id,
                    //     store_name: store.name,
                    //     value: 0
                    //   });
                    // }

                    let filter_by_price = this.formData.prices_by_stores.filter(
                        item => item.store === store.id
                    );
                    if (filter_by_price.length === 0) {
                        this.formData.prices_by_stores.push({
                            store: store.id,
                            store_name: store.name,
                            value: 0,
                            trade_value: 0,
                        });
                    }
                }
            })
    };

    // Установка срока годности
    _app.methods.setExpireDate = function (date_str, date2) {
        this.formData.expiration_date = date_str;
    };

    // Загрузка и удаление картинки
    _app.methods.onSuccessImageUpload = function (response, file, fileList) {
        this.formData.image = response.filename;
        this.formData.image_url = response.url;
    };
    _app.methods.deleteImage = function () {
        this.formData.image = "";
        this.formData.image_url = "";
    };

    // Обработчик, срабатывающие на изменение закупочной цены/наценки/конечной цены
    _app.methods.onChangePurchase = function (purchase) {
        purchase = parseFloat(purchase);
        let markup_price = parseFloat(this.formData.markup_price);

        if (!purchase) {
            this.formData.base_price = 0;
        } else {
            if (markup_price) {
                let base_price = purchase + (purchase * markup_price) / 100;
                this.formData.base_price = base_price.toFixed(0);
            } else {
                this.formData.base_price = purchase.toFixed(0);
            }
        }
    };
    _app.methods.onChangeMarkupPrice = function (markup_price) {
        markup_price = parseFloat(markup_price);
        if (markup_price) {
            let purchase = parseFloat(this.formData.purchase);
            let base_price = purchase + (purchase * markup_price) / 100;
            this.formData.base_price = base_price.toFixed(0);
        }
    };
    _app.methods.onChangeBasePrice = function (base_price) {
        if (this.formData.type === TYPE_PRODUCT) {
            base_price = parseFloat(base_price);
            if (base_price) {
                let purchase = parseFloat(this.formData.purchase);
                let markup_price = ((base_price - purchase) / purchase) * 100;
                let _markup_price = markup_price.toFixed(2);
                if (isFinite(_markup_price)) {
                    this.formData.markup_price = _markup_price;
                } else {
                    this.formData.markup_price = 0;
                }
            }
            // else {
            //   this.formData.purchase = 0;
            // }
        }
    };
    _app.methods.onChangeTradePrice = function (trade_price) {
        if (this.formData.type === TYPE_PRODUCT) {
            trade_price = parseFloat(trade_price);
            // if (trade_price) {
            //     let purchase = parseFloat(this.formData.purchase);
            //     let markup_price = ((base_price - purchase) / purchase) * 100;
            //     let _markup_price = markup_price.toFixed(2);
            //     if (isFinite(_markup_price)) {
            //         this.formData.markup_price = _markup_price;
            //     } else {
            //         this.formData.markup_price = 0;
            //     }
            // }
            // else {
            //   this.formData.purchase = 0;
            // }
        }
    };

    _app.methods.attachNewGroup = function (group_id) {
        this.getGroup();
        this.formData.group = group_id;
    };

    // Получение кода товара
    _app.methods.getNextProductCode = function () {
        const path = "/catalog/products/next_code/?format=json";
        this.$http
            .get(base_url + path)
            .then(result => {
                this.formData.code = result.data.code;
            })
    };

    _app.methods.generateBarcode = function () {
        const path = "/catalog/products/barcode/?code=" + this.formData.code;
        this.$http
            .get(base_url + path)
            .then(result => {
                this.formData.barcode = result.data.barcode;
                this.generatedBarcode = true;
            })

    };

    // Регистронещзависимый поиск(КОМПЛЕКТ)
    _app.methods.kitCompositionFilter = function (value, option) {
        return option.toUpperCase().indexOf(value.toUpperCase()) !== -1;
    };

    // Загрузка товаров для последующего добавления в целевую таблицу(КОМПЛЕКТ)
    _app.methods.fetchProductsForKit = function (filtered = false) {
        const url = base_url + "/catalog/products/";
        this.kit_composition.source_table.loading = true;
        this.kit_composition.source_table.last_draw++;

        let params = {
            format: "table",
            draw: this.kit_composition.source_table.last_draw,
            offset:
                this.kit_composition.source_table.limit *
                this.kit_composition.source_table.current_page -
                this.kit_composition.source_table.limit,
            limit: this.kit_composition.source_table.limit,
            search: this.kit_composition.search_value,
            for_kit: true
        };

        this.$http
            .get(url, {params: params})
            .then(result => {
                if (result.data.draw === this.kit_composition.source_table.last_draw) {
                    if (filtered) {
                        this.kit_composition.source_table.data = result.data.results;
                    } else {
                        for (let product of result.data.results) {
                            this.kit_composition.source_table.data.push(product);
                        }
                    }

                    this.kit_composition.source_table.total_records = result.data.count;
                }
            })
            .finally(() => {
                this.kit_composition.source_table.loading = false;
            });
    };

    // Добовление товара в целевую таблицу (КОМПЛЕКТ)
    _app.methods.addToKitTargetTable = function (data, index) {
        this.kitHasBasePrice = false;
        this.kitHasTradePrice = false;

        for (const [counter, item] of this.kit_composition.target_table.entries()) {
            if (item.id === data.id) {
                this.kit_composition.target_table[counter].count++;
                // this.formData.base_price = parseFloat(this.formData.base_price) + parseFloat(data.base_price);
                return;
            }
        }

        this.kit_composition.target_table.push({
            id: data.id,
            name: data.name,
            base_price: data.base_price,
            trade_price: data.trade_price,
            count: 1
        });

        // this.formData.base_price = parseFloat(this.formData.base_price) + parseFloat(data.base_price);
    };

    // Удаление товара из целеыой таблицы (КОМПЛЕКТ)
    _app.methods.deleteFromKitTargetTable = function (id) {
        this.kitHasBasePrice = false;
        this.kitHasTradePrice = false;

        for (const [counter, item] of this.kit_composition.target_table.entries()) {
            if (item.id === id) {
                this.kit_composition.target_table.splice(counter, 1);
                return;
            }
        }
    };

    _app.methods.fetchInitialData = function () {
        this.$http
            .get(this.base_view_url + this.id + "/")
            .then(response => {
                this.formData = response.data;

                for (let field in this.formData) {
                    this.formData[field] = response.data[field];
                }
                
                //console.log('Start init!')
                this.isInitial = true;
                //console.log(this.isInitial)
                // this.fetchSchema();
                // Получаем данные для набора (target_table)
                if (response.data.type === TYPE_KIT) {
                  for (let item of response.data.kit) {
                    this.kit_composition.target_table.push({
                      id: item.child_product,
                      name: item.child_product_name,
                      base_price: item.base_price,
                      trade_price: item.trade_price,
                      count: item.amount
                    });
                  }
                  // if (this.target_table.length > 0) {
                    //   this.kitHasBasePrice = true;
                    //   this.kitHasTradePrice = true;
                    // }
                  }
                  
                  // Получаем данные для набора (source_table)
                  this.fetchProductsForKit();
                  
                  this.getStores();
                  
                  
                })
                .finally(() => {
                  this.loading = false;
                  //console.log('End init!')
                  this.isInitial = false;
                  //console.log(this.isInitial)
                });
    };

    _app.computed.dataForSave = function () {
        let data = this.formData;
        if (!data.discount || data.discount < 0) data.discount = 0;
        data.kit = [];
        for (let item of this.kit_composition.target_table) {
            data.kit.push({child_product: item.id, amount: item.count});
        }

        if (!this.formExtra.prices_by_stores) {
            this.formData.prices_by_stores = []
        }
        // if (data.type === TYPE_SERVICE || data.type === TYPE_KIT){
        //    data.rest_by_stores = [];
        // }
        return data;
    };

    _app.computed.httpMethod = function () {
        let http_method = "put";
        if (this.action === "create") {
            http_method = "post";
        }
        return http_method;
    };

    _app.computed.urlForSave = function () {
        return this.action === "create" ? this.base_view_url : `${this.base_view_url}${this.id}/`;
    };

    _app.methods.save = function () {
        let http_method = this.httpMethod;
        let url = this.urlForSave;
        let data = this.dataForSave;

        this.loading = true;
        this.$http[http_method](url, data)
            .then(response => {
                this.$Message.success("Успешно сохранено");
                this.$router.push({
                    name: this.item_type + "_detail",
                    params: {id: response.data.id}
                });
                // this.showDetail(response.data.id);
                if (this.action === "create") {
                    this.$emit("change", response.data.id);
                }
                this.$emit("reload_table");
            })
            .finally(() => {
                this.loading = false;
            });
    };

    // _app.methods.saveCategory = function() {
    //   const url = base_url + "/options/category/";
    //   let data = { name: this.newCategoryModal.value };
    //   // this.formData.categories.push('0a4c89e3-0c56-4890-bb4f-76791a199da2');
    //
    //   this.$http
    //     .post(url, data)
    //     .then(response => {
    //       this.$Message.success("Успешно сохранено");
    //       this.formSelectOptions.category.push({id: response.data.id, name: response.data.name});
    //       // this.getCategory();
    //       this.formData.categories.push(response.data.id);
    //       // this.$set(this.formData.categories, 0, response.data.id);
    //     })
    //     .finally(() => {
    //       this.newCategoryModal.modal_loading = false;
    //       this.newCategoryModal.show = false;
    //     });
    // };
    // _app.methods.saveSupplier = function() {
    //   const url = base_url + "/suppliers/";
    //   let data = { name: this.newSupplierModal.value };
    //
    //   this.$http
    //     .post(url, data)
    //     .then(response => {
    //       this.$Message.success("Успешно сохранено");
    //       this.getSupplier();
    //       this.formData.supplier = response.data.id;
    //     })
    //     .finally(() => {
    //       this.newSupplierModal.modal_loading = false;
    //       this.newSupplierModal.show = false;
    //     });
    // };

    // _app.methods.newCategoryModalSave = function() {
    //   this.newCategoryModal.modal_loading = true;
    //   this.saveCategory();
    // };
    // _app.methods.newSupplierModalSave = function() {
    //   this.newSupplierModal.modal_loading = true;
    //   this.saveSupplier();
    // };

    _app.methods.formatNumber = function (num) {
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");
    };

    _app.methods.addWatcherToKit = function() {
      this.$watch('kit_composition.target_table', {
        handler: function (val, oldVal) {
          // if (oldVal && val && oldVal.length == val.length) {
          //   for (let i = 0; i < val.length; i++) {
          //     console.log(oldVal[i], val[i]);
          //     // Проверяем, изменилось ли свойство count
          //     if (val[i].count !== oldVal[i].count) {
          //       break;
          //     }
          //   }
          // }
          if (this.isInitial == false) {
            this.kitHasBasePrice = false;
            this.kitHasTradePrice = false;
          }
          //console.log(this.kitHasBasePrice, this.kitHasTradePrice);
          
          if (!this.kitHasBasePrice) {
            this.formData.base_price = 0;
            if (val) {
              for (const key in this.kit_composition.target_table) {
                this.formData.base_price +=
                  parseFloat((this.kit_composition.target_table[key].base_price *
                    this.kit_composition.target_table[key].count).toFixed(2));
            // var base_price = 0;
            // if (val && this.formData && this.formData.prices_by_stores) {
            //   for (const key in this.formData.prices_by_stores) {
            //     if (this.kit_composition.target_table[key]) {
            //       base_price +=
            //         parseFloat((this.kit_composition.target_table[key].base_price *
            //           this.kit_composition.target_table[key].count).toFixed(2));
            //     }
              }
            }
          }
          if (!this.kitHasTradePrice) {
            this.formData.trade_price = 0;
            if (val) {
              for (const key in this.kit_composition.target_table) {
                this.formData.trade_price +=
                  parseFloat((this.kit_composition.target_table[key].trade_price *
                    this.kit_composition.target_table[key].count).toFixed(2));
              }
            }
          }
          //console.log(this.formData.base_price);
          //console.log(this.formData.trade_price);
        },
        deep: true
      });
    };

    //      Калькулятор цен
    // _app.watch["formData.purchase"] = function(val, oldVal) {
    //   this.onChangePurchase(val);
    // };
    // _app.watch["formData.markup_price"] = function(val, oldVal) {
    //   this.onChangeMarkupPrice(val);
    // };
    // _app.watch["formData.base_price"] = function(val, oldVal) {
    //   this.onChangeBasePrice(val);
    // };

    // Перключатель "Установить разные цены в магазинах". Если включено - показываем одинаковую с базовой наценку и цену
    _app.watch["formExtra.prices_by_stores"] = function (val, oldVal) {
        if (val && this.action === "create") {
            this.formData.prices_by_stores.forEach((val, index) => {
                this.formData.prices_by_stores[index].value = this.formData.base_price;
                this.formData.prices_by_stores[index].trade_value = this.formData.type === TYPE_SERVICE? 0 : this.formData.trade_price;
            });
        }
    };

    // Поиск товара для набора (КОМПЛЕКТ)
    _app.watch["kit_composition.search_value"] = function () {
        this.kit_composition.source_table.current_page = 1;
        this.fetchProductsForKit(true);
    };
    // Скроллинг товаров (КОМПЛЕКТ)
    _app.watch["kit_composition.source_table.current_page"] = function () {
        this.fetchProductsForKit();
    };

    // _app.watch["kit_composition.target_table"] = {
    //     handler: function (val, oldVal) {
    //         this.formData.base_price = 0;
    //         if (val) {
    //             for (const key in this.formData.prices_by_stores) {
    //                 this.formData.base_price +=
    //                     this.kit_composition.target_table[key].base_price *
    //                     this.kit_composition.target_table[key].count;
    //             }
    //         }
    //     },
    //     deep: true
    // };

    _app.watch["newGroupModal.show"] = function (val, oldVal) {
        if (!val) {
            this.getGroup();
        }
    };

    _app.mounted = function () {
        this.getGroup();
        // this.getSupplier();
        // this.getCategory();
        if (this.action === "create") this.getStores();

        if (this.action === "edit") this.formExtra.prices_by_stores = true;
        this.getNextProductCode();
        this.addWatcherToKit();
    };

    export default _app;
</script>


<style scoped>
  .form__product_type,
  .form__product_type__active {
    cursor: pointer;
    text-align: center !important;
    margin-bottom: 35px;
    border: none;
  }

  .form__product_type__text {
    font-size: 16px;
    font-weight: bold;
    color: rgba(14, 37, 74, 0.3);
  }

  .card-container h2 {
    border-bottom: 1px solid #e8eaec;
    padding: 14px 16px;
  }

  .card-container p {
    padding: 16px;
  }

  .form_extra {
    margin-bottom: 20px;
    background: whitesmoke;
  }

  .form__product_type__active {
    background-color: #20BEC8;
  }

  .form__product_type__active h2 {
    color: #ffffff;
  }

  .form__product_type__active .form__product_type__text {
    color: rgba(255, 255, 255, 1);
  }

  .no-select {
    text-align: center;
    font-size: 28px;
    color: rgba(191,191,191,.87);
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .upload_image {
    display: inline-block;
    width: 90%;
    max-width: 150px;
    max-height: 150px;
    text-align: center;
    line-height: 60px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
    margin-right: 4px;
  }

  .upload_image img {
    width: 100%;
    height: 100%;
  }

  .upload_image_cover {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
  }

  .upload_image:hover .upload_image_cover {
    display: block;
  }

  .upload_image_cover i {
    color: #fff;
    font-size: 40px;
    cursor: pointer;
    margin-top: 50px;
  }

  .btn-small {
    border-radius: 30px;
  }

  .alert-msg {
    margin: 32px 0;
    width: 50%;
    border: none;
    background-color: #F1F1F1;
    font-size: 16px;
    color: rgba(14, 37, 74, 0.6);
    padding: 12px 20px;
    line-height: 1.5;
  }

  .alert-msg img {
    margin-right: 24px;
  }

  .btn-add {
    margin-top: 33px;
    margin-left: 10px;
    height: 56px;
    padding: 0 24px
  }


  .left__col {
    border-right: 1px dashed rgba(14,37,74,0.3);
    padding-right: 70px;
  }

  .right__col {
    padding-left: 70px;
  }

  .card-container__label {
    font-size: 16px;
    padding: 10px 40px;
  }

  .сard-container__type-kit {
    padding: 10px 20px;
  }

  @media screen and (max-width: 1900px) {
    .btn-add {
      height: 46px;
    }
  }

  @media screen and (max-width: 1200px) {
    .alert-msg {
      width: 100%;
    }
  }

  @media screen and (max-width: 991px) {
    .form__product_type__active {
      background-color: #5087DE;
    }

    .card-container h2 {
      border-bottom: none;
      padding: 10px 20px;
    }

    .card-container p{
      display: none;
    }

    .unselectable {
      display: flex;
    }

    .unselectable .card-container {
      margin-right: 24px;
    }

    .unselectable .card-container:last-child {
      margin-right: 0;
    }


    .left__col {
      border-right: none;
      padding-right: 0;
    }

    .right__col {
      padding-left: 0;
    }

    .alert-msg {
      flex-direction: column;
    }

    .alert-msg img {
      display: block;
      margin: 0 auto 12px 0;
      width: 25px;
    }

    .сard-container__type-kit {
      padding: 0;
      box-shadow: none;
    }

    .no-select {
      margin-top: 50px;
      margin-bottom: 50px;
      font-size: 20px;
    }

  }


  @media screen and (max-width: 575px) {
    .card-container h2 {
      padding: 8px 15px;
      font-size: 13px;
    }

    .card-container__label {
      font-size: 15px;
      padding: 10px;
    }
  }



</style>
<style>
  .kit_source_table_column {
    cursor: pointer;
  }


</style>



// WEBPACK FOOTER //
// src/apps/catalog/catalogForm.vue